"use client";
import React, { useState, KeyboardEvent, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { get, post, remove } from "../../redux/ApiHelper";

const SubscriptionBenefitsItems = () => {
  const [items, setItems] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getItems = async () => {
      try {
        const res = await get("/info/");
        setItems(res.subscriptionBenefitsListItems);
      } catch (error) {}
    };
    getItems();
  }, []);
  const addItem = async () => {
    const trimmed = inputValue.trim();
    if (trimmed && !items.includes(trimmed)) {
      setLoading(true);
      setItems((prev) => [...prev, trimmed]);
      setInputValue("");
      try {
        const response = await post("/info/subscription-benefits-items", {
          item: trimmed,
        });
        // console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addItem();
    }
  };

  const removeItem = async (index: number) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
    try {
      const res = await remove(`/info/subscription-benefits-items/${index}`);
    //   console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto space-y-4 mt-5">
      <label className="block text-yellow-500 font-medium text-2xl">
        Subscription benefits list items
      </label>

      <div className="flex flex-wrap items-center gap-2 p-2 border border-gray-300 rounded-md bg-white shadow-sm min-h-[3rem]">
        {items.map((item, index) => (
          <span
            key={index}
            className="flex items-center bg-yellow-100 text-black px-3 py-1 rounded-full text-sm font-medium shadow-sm"
          >
            {item}
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="ml-2 bg-red-400 hover:bg-red-500 transition"
            >
              <RxCross2 color="" />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type and press Enter to save"
          className="flex-1 min-w-[8rem] px-2 py-1 text-sm focus:outline-none text-black"
        />
      </div>

      <div className="text-sm text-gray-600">Total Items: {items.length}</div>
    </div>
  );
};

export default SubscriptionBenefitsItems;
